module.exports = __webpack_public_path__ + "img/paper.bb2af23c.png";